export default class Page {
  handleClick(element, mode="new") {
    let type = element.value;

    const performChange = () => {
      if (type == 'pdf') {
        $('#typePdf').removeClass('d-none')
        $('#typeText').addClass('d-none')
      } else if (type == 'text') {
        $('#typeText').removeClass('d-none')
        $('#typePdf').addClass('d-none')
      }
    };

    if (mode !== 'new' && mode !== 'create') {
      Popup.confirm(
        `作成方法を変更、または新しいデータをアップロードすると、<br>現在の作成済みデータは削除されます（復元できません）。<br>変更してよろしいですか？`,
        {
          success: () => { performChange(); },
          cancel: () => {
            if (type == 'pdf') {
              $('input[name="page[contract_type]"][value="text"]').prop('checked', true);
            } else {
              $('input[name="page[contract_type]"][value="pdf"]').prop('checked', true);
            }
          },
          confirmText: '作成方法を変更する',
          width: 'auto',
        }
      )
    } else {
      performChange();
    }
  }

  clickButtonUpload() {
    $('#upload_file').click();
  }

  clickButtonDeletePage(id){
    Popup.confirm(`削除後は復元できません。<br>削除してよろしいですか？`, {
      cancelBtn: false,
      confirmText: 'OK',
      success: () => {
        $(`a.delete-page-${id}`)[0].click();
      }
    })
  }
}
